export default "__VITE_ASSET__B6Qlv0Vw__"